<div class="container">
  <div class="sub-container">
    <app-docs-tree />
    <app-docs-renderer [markdown]="(currentDoc | async) || 'ntohgin'"/>
  </div>
</div>
